import { Component, input } from '@angular/core';

@Component({
  selector: 'app-visual-element',
  imports: [],
  templateUrl: './visual-element.component.html',
  styleUrl: './visual-element.component.css',
})
export class VisualElementComponent {
  url = input.required<string>();
  fit = input.required<'contain' | 'cover' | 'fill'>();
  color = input<string>();
}
